<template>
  <div class="user-container">
    <div class="table-fields">
      <el-row class="my-row">
        <label style="margin:0 30px;">收费单位:</label>
        <el-select v-model="payItemListVO.companyId" placeholder="请选择">
          <el-option v-for="item in companyArry" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
        </el-select>
        <label style="margin:0 30px;">收费类型:</label>
        <el-select v-model="payItemListVO.typeId" placeholder="请选择">
          <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <label style="margin:0 30px;">状态:</label>
        <el-select v-model="payItemListVO.status" placeholder="请选择">
          <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-button style="margin:0 30px;" type="primary" @click="handleSearch">搜索</el-button>
        <el-button type="warning" @click="dialogVisible = true">
          新增
          <i class="el-icon-plus el-icon--right"></i>
        </el-button>
      </el-row>
    </div>
    <el-table
      :data="tableData"
      :row-style="{height:'30px'}"
      :cell-style="{padding:'5px 0'}"
      style="width: 100%"
      height="580px"
      :border="true"
      :header-cell-style="{background: '#f2f2f2'}"
    >
      <el-table-column prop="name" label="项目名称"></el-table-column>
      <el-table-column prop="typeName" label="所属类型"></el-table-column>
      <el-table-column prop="amount" label="默认收费金额"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" type="danger">未启用</el-tag>
          <el-tag v-if="scope.row.status === 2" type="success">已启用</el-tag>
          <el-tag v-if="scope.row.status === 3" type="warning">已禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createDateTime" label="创建时间"></el-table-column>
      <el-table-column prop="updateDateTime" label="更新时间"></el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="handleClickActive(scope.row.id)"
            type="success"
            size="mini"
            icon="el-icon-caret-right"
            v-if="scope.row.status !== 2 "
          >启用</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="handlDelete(scope.row.id)"
            v-if="scope.row.status === 2"
            size="mini"
          >禁用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="新增收费项目" :visible.sync="dialogVisible" width="400px">
      <el-form :model="payItemVO">
        <el-form-item label="收费单位">
          <el-select v-model="payItemVO.companyId" placeholder="请选择">
            <el-option v-for="item in companyArry" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收费类型">
          <el-select v-model="payItemVO.typeId" placeholder="请选择">
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model="payItemVO.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="默认收费金额">
          <el-input v-model="payItemVO.amount" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCommit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  payItemList,
  payTypeList,
  enabelPayItem,
  forbidPayItem,
  addPayItem,
  companyList
} from "@/axios/api";
export default {
  data() {
    return {
      tableData: [],
      payItemListVO: {
        status: "",
        typeId: "",
        companyId: ''
      },
      dialogVisible: false,
      typeList: [],
      statusList: [
        { id: "", name: "全部" },
        { id: "1", name: "未启用" },
        { id: "2", name: "已启用" },
        { id: "3", name: "已禁用" }
      ],
      payItemVO: {
        typeId: "",
        name: "",
        amount: 0
      },
      companyArry: []
    };
  },
  methods: {
    handleCompanyList() {
          companyList().then(res => {
            if (res.status === 200) {
              this.companyArry = res.data || []
            }
          })
      },
    handleCommit() {
      addPayItem(this.payItemVO).then(res => {
        this.dialogVisible = false;
        if (res.status === 200) {
          this.getPayItemList();
          this.$message.success("操作成功！");
          this.getPayItemList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handlDelete(id) {
      forbidPayItem(id).then(res => {
        if (res.status === 200) {
          this.$message.success("操作成功！");
          this.getPayItemList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleClickActive(id) {
      enabelPayItem(id).then(res => {
        if (res.status === 200) {
          this.$message.success("操作成功！");
          this.getPayItemList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSearch() {
      this.getPayItemList();
    },
    getPayItemList() {
      payItemList(this.payItemListVO).then(res => {
        if (res.status === 200) {
          this.tableData = res.data;
        }
      });
    },
    getPayTypeList() {
      payTypeList(this.payItemListVO).then(res => {
        if (res.status === 200) {
          this.typeList = res.data;
        }
      });
    }
  },
  mounted() {
    this.handleCompanyList();
  },
  watch: {
    'payItemListVO.companyId'() {
      this.getPayTypeList();
    },
    dialogVisible(val) {
      if (val) this.payItemVO.companyId = this.payItemListVO.companyId;
    }
  }
};
</script>

<style scoped>
.my-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.table-fields {
  width: 100%;
  height: 80px;
  border: 1px solid #ebebeb;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 30px;
  box-sizing: border-box;
}
.user-container {
  width: 100%;
  height: auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/pay/PayItem.vue